module.exports = __webpack_public_path__ + "static/media/loginlogo.2cd6f1a7.svg";